export type UserImage = {
  id: string;
  title: string;
  image: File;
  imageLocation: string;
  remoteName: string;
};

export interface PaginationQuery {
  pagination: {
    pageNumber: string;
    itemsPerPage: string;
  } | null;
}
export interface ListInventoryResponse {
  skuItems: VehicleSummary[];
  currentQuery: PaginationQuery;
}

export interface VehicleSummary {
  averageAnnualMileage: number;
  averageAnnualMileageUnits: string;
  emissionStandard: string;
  fuelType: string;
  images: UserImage[];
  vehicleCapacity: {
    maxCapacityDimensions: {
      width: number;
      height: number;
      length: number;
      dimensionsUnitOfMeasure: string;
    };
    maxPallets: number;
    maxKilograms: number;
  };
  model: string;
  modifiedAt: string;
  registrationNumber: string;
  userBusinessId: string;
  userId: string;
  vehicleId: string;
  vehicleType: string;
  vehicleCategory: string;
  specialEquipment: string[];
}

export type Fleet =
  | 'VanLessThan1AndHalft'
  | 'LgvLessThan3AndHalft'
  | 'TwoAxleRigidLessThan7AndHalf5t'
  | 'TwoAxleRigid18t'
  | 'TwoAxleRigidLessThan26t'
  | 'MultiAxleArticMoreThan26t'
  | 'SpecialOrOther';

export const fleetMapping: Record<string, string> = {
  VanLessThan1AndHalft: 'Light Van',
  LgvLessThan3AndHalft: 'Light Commercial',
  TwoAxleRigidLessThan7AndHalf5t: 'Small Rigid',
  TwoAxleRigid18t: 'Medium Rigid',
  TwoAxleRigidLessThan26t: 'Large Rigid',
  ThreeAxleRigidLessThan26t: 'Large Rigid',
  MultiAxleArticMoreThan26t: 'Heavy Articulated',
  SpecialOrOther: 'Special/Other',
};

export const fleetSubtitleMapping: Record<string, string> = {
  VanLessThan1AndHalft: 'Van < 1.5t',
  LgvLessThan3AndHalft: 'LDV < 3.5t',
  TwoAxleRigidLessThan7AndHalf5t: '2 Axle Rigid < 7.5t',
  TwoAxleRigid18t: '2 Axle Rigid < 18t',
  TwoAxleRigidLessThan26t: '2 Axle Rigid < 26t',
  ThreeAxleRigidLessThan26t: '3 Axle Rigid < 26t',
  MultiAxleArticMoreThan26t: 'Multi-Axle Artic > 26t',
  SpecialOrOther: 'Specialist or Other',
};
